
        import 'Spinner.532cc02.css-module'
        export default {"spinner":"spinner_Spinner_532cc02","peachySpinner__spin":"peachySpinner__spin_Spinner_532cc02"}
    